import { SPACING_UNIT } from 'src/theme';

type Space = number | 'auto';

export type SpacingProps = {
  p?: Space;
  pt?: Space;
  pb?: Space;
  pl?: Space;
  pr?: Space;
  ph?: Space;
  pv?: Space;
  m?: Space;
  mt?: Space;
  mb?: Space;
  ml?: Space;
  mr?: Space;
  mh?: Space;
  mv?: Space;
  gap?: number;
};

const sizeProps = [
  'p',
  'pt',
  'pb',
  'pl',
  'pr',
  'ph',
  'pv',
  'm',
  'mt',
  'mb',
  'ml',
  'mr',
  'mh',
  'mv',
  'gap',
];

export const calculateSpacing = (value: number): number => value * SPACING_UNIT;

export const formatSpacing = (props: SpacingProps) => {
  const styles: string[] = [];
  for (const key of sizeProps) {
    const value = props[key as keyof SpacingProps];

    if (value === undefined) {
      continue;
    }

    const calculatedValue = typeof value === 'string' ? value : `${calculateSpacing(value)}px`;

    switch (key) {
      case 'gap':
        styles.push(`gap: ${calculatedValue};`);
        break;
      case 'p':
        styles.push(`padding: ${calculatedValue};`);
        break;
      case 'pt':
        styles.push(`padding-top: ${calculatedValue};`);
        break;
      case 'pb':
        styles.push(`padding-bottom: ${calculatedValue};`);
        break;
      case 'pl':
        styles.push(`padding-left: ${calculatedValue};`);
        break;
      case 'pr':
        styles.push(`padding-right: ${calculatedValue};`);
        break;
      case 'ph':
        styles.push(`padding-left: ${calculatedValue};`);
        styles.push(`padding-right: ${calculatedValue};`);
        break;
      case 'pv':
        styles.push(`padding-top: ${calculatedValue};`);
        styles.push(`padding-bottom: ${calculatedValue};`);
        break;
      case 'm':
        styles.push(`margin: ${calculatedValue};`);
        break;
      case 'mt':
        styles.push(`margin-top: ${calculatedValue};`);
        break;
      case 'mb':
        styles.push(`margin-bottom: ${calculatedValue};`);
        break;
      case 'ml':
        styles.push(`margin-left: ${calculatedValue};`);
        break;
      case 'mr':
        styles.push(`margin-right: ${calculatedValue};`);
        break;
      case 'mh':
        styles.push(`margin-left: ${calculatedValue};`);
        styles.push(`margin-right: ${calculatedValue};`);
        break;
      case 'mv':
        styles.push(`margin-top: ${calculatedValue};`);
        styles.push(`margin-bottom: ${calculatedValue};`);
        break;
      default:
        break;
    }
  }
  return styles.join('\n');
};
